import type { InputHTMLAttributes } from 'react';
import './Input.css';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  id: string;
}

/**
 * Beschriftetes Textfeld. Label liegt immer sichtbar ueber dem Feld - keine
 * reinen Platzhalter-Labels, die beim Tippen verschwinden.
 */
export function Input({ label, id, className, ...props }: InputProps) {
  const classes = ['input-field__control', className].filter(Boolean).join(' ');
  return (
    <div className="input-field">
      <label htmlFor={id} className="input-field__label">
        {label}
      </label>
      <input id={id} className={classes} {...props} />
    </div>
  );
}
